import styled from 'styled-components'

export const Image = styled.img`
  width: 90px;
  height: 90px;
  object-fit: cover;
`
